var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.267,
    height: 37.681,
    viewBox: "0 0 41.267 37.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_353",
    "data-name": "Rectangle 353",
    width: 41.267,
    height: 37.681,
    fill: "#c7c7c7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M40.811,7.208a1.973,1.973,0,0,1,.415,1.667L38.391,22.449a2.026,2.026,0,0,1-1.984,1.6H11.349l.6,2.857H36.219a1,1,0,1,1,0,2H11.945a2.028,2.028,0,0,1-1.985-1.6L5.057,3.822.61,1.916A.994.994,0,0,1,.085.6,1.017,1.017,0,0,1,1.417.083l4.448,1.9A2.008,2.008,0,0,1,7.042,3.418L7.68,6.471H39.241a2.029,2.029,0,0,1,1.57.736m-4.4,14.838L39.241,8.471H8.1l2.834,13.575Z",
    transform: "translate(0 0)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M44.8,44.443a3.581,3.581,0,1,1-3.629,3.581A3.609,3.609,0,0,1,44.8,44.443m1.6,3.581a1.6,1.6,0,1,0-1.6,1.581,1.594,1.594,0,0,0,1.6-1.581",
    transform: "translate(-14.766 -13.924)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M39.537,16.984a1,1,0,1,1,0,2H25.017a1,1,0,1,1,0-2Z",
    transform: "translate(-8.609 -5.321)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M39.189,24.545a1,1,0,1,1,0,2H26.25a1,1,0,1,1,0-2Z",
    transform: "translate(-9.051 -7.69)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M24.951,44.443a3.581,3.581,0,1,1-3.629,3.581,3.61,3.61,0,0,1,3.629-3.581m1.6,3.581a1.6,1.6,0,1,0-1.6,1.581,1.594,1.594,0,0,0,1.6-1.581",
    transform: "translate(-7.647 -13.924)",
    fill: "#c7c7c7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.143fe9dcdaf0339e35ff49cb89ea5881.svg";
export { ForwardRef as ReactComponent };